import { render, staticRenderFns } from "./WithdrawWaitConfirm.vue?vue&type=template&id=c83cdfda"
import script from "./WithdrawWaitConfirm.vue?vue&type=script&lang=js"
export * from "./WithdrawWaitConfirm.vue?vue&type=script&lang=js"
import style0 from "./WithdrawWaitConfirm.vue?vue&type=style&index=0&id=c83cdfda&prod&lang=scss&scooped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports